import { render, staticRenderFns } from "./SectionObserver.vue?vue&type=template&id=6c420876&scoped=true"
import script from "./SectionObserver.vue?vue&type=script&lang=js"
export * from "./SectionObserver.vue?vue&type=script&lang=js"
import style0 from "./SectionObserver.vue?vue&type=style&index=0&id=6c420876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c420876",
  null
  
)

export default component.exports